import dayjs from "dayjs";
import { CommunityFilterValues } from "../components/filter.community";

/**
 * Turns the filter toolbar's form state into the query params for
 * GET community/list. Pure so it can be unit tested without rendering
 * anything: empty fields are omitted entirely rather than sent as "",
 * and the date range is expanded to start-of-day / end-of-day so a
 * single-day range ("today" to "today") still matches that day's posts.
 */
export function buildListParams(filter: CommunityFilterValues) {
  const params: Record<string, string> = {
    sort_by: "DES",
    order_by: "DESC",
    post_status: filter.status || "all",
  };

  if (filter.keyword.trim() !== "") {
    params.search = filter.keyword.trim();
  }

  if (filter.authorId) {
    params.user_id = filter.authorId;
  }

  if (filter.dateFrom) {
    params.created_from = String(dayjs(filter.dateFrom).startOf("day").valueOf());
  }

  if (filter.dateTo) {
    params.created_to = String(dayjs(filter.dateTo).endOf("day").valueOf());
  }

  return params;
}
